module.exports = __webpack_public_path__ + "img/Ignacio2.491a4083.png";